const displayType = {
  None: null,
  Default: 'Default',
  NASBA: 'NASBA',
};

const templateType = {
  LiveClassScheduler: 'LiveClassScheduler',
  OnlineCourses: 'OnlineCourses',
  LibraryProduct: 'LibraryProduct',
  ProductSearchA: 'ProductSearchA',
  ProductSearchB: 'ProductSearchB',
};

export { displayType, templateType };
